import { cloneDeep } from 'lodash';
import { AbstractEntity } from "../AbstractEntity";
import Signature from "../Signature";
import { getUtcNow } from "../../utils";
export default class VesselParticulars extends AbstractEntity {
    static createNewVersion(vesselParticulars, author) {
        const newVesselParticulars = {
            version: vesselParticulars.version + 1,
            author,
            administrationForDocumentOfCompliance: vesselParticulars.administrationForDocumentOfCompliance,
            administrationForSafetyManagementCertificate: vesselParticulars.administrationForSafetyManagementCertificate,
            auditorForDocumentOfCompliance: vesselParticulars.auditorForDocumentOfCompliance,
            auditorForSafetyManagementCertificate: vesselParticulars.auditorForSafetyManagementCertificate,
            auditorForSecurityCertificate: vesselParticulars.auditorForSecurityCertificate,
            dateOfIssuanceForDocumentOfCompliance: vesselParticulars.dateOfIssuanceForDocumentOfCompliance,
            dateOfExpiryForDocumentOfCompliance: vesselParticulars.dateOfExpiryForDocumentOfCompliance,
            dateOfIssuanceForSafetyManagementCertificate: vesselParticulars.dateOfIssuanceForSafetyManagementCertificate,
            dateOfExpiryForSafetyManagementCertificate: vesselParticulars.dateOfExpiryForSafetyManagementCertificate,
            dateOfIssuanceForInternationalShipSecurityCertificate: vesselParticulars.dateOfIssuanceForInternationalShipSecurityCertificate,
            dateOfExpiryForInternationalShipSecurityCertificate: vesselParticulars.dateOfExpiryForInternationalShipSecurityCertificate,
            grossTonnage: vesselParticulars.grossTonnage,
            netTonnage: vesselParticulars.netTonnage,
            lengthOverall: vesselParticulars.lengthOverall,
            breadthOverall: vesselParticulars.breadthOverall,
            workingLanguage: vesselParticulars.workingLanguage,
            callSign: vesselParticulars.callSign,
            mmsiNumber: vesselParticulars.mmsiNumber,
            shipType: vesselParticulars.shipType,
            seaArea: vesselParticulars.seaArea,
            equipmentAvailability: vesselParticulars.equipmentAvailability,
            unlimitedEnginePower: vesselParticulars.unlimitedEnginePower,
            limitedEnginePower: vesselParticulars.limitedEnginePower,
            unlimitedShaftPower: vesselParticulars.unlimitedShaftPower,
            limitedShaftPower: vesselParticulars.limitedShaftPower,
            companyDetails: vesselParticulars.companyDetails,
            charterers: cloneDeep(vesselParticulars.charterers),
            classes: cloneDeep(vesselParticulars.classes),
            companyResponsibleForVesselManagement: cloneDeep(vesselParticulars.companyResponsibleForVesselManagement),
            flagStates: cloneDeep(vesselParticulars.flagStates),
            portOfRegistration: vesselParticulars.portOfRegistration,
            vesselIMO: vesselParticulars.vesselIMO,
            vesselName: vesselParticulars.vesselName,
            vesselOwners: cloneDeep(vesselParticulars.vesselOwners),
            logbooksKeptAdditionally: cloneDeep(vesselParticulars.logbooksKeptAdditionally),
            ismRelevantChecklists: cloneDeep(vesselParticulars.ismRelevantChecklists),
            checklists: cloneDeep(vesselParticulars.checklists),
            staticDocuments: cloneDeep(vesselParticulars.staticDocuments),
        };
        const newVersion = new VesselParticulars(newVesselParticulars);
        return newVersion;
    }
    createdTimestamp;
    author;
    administrationForDocumentOfCompliance;
    administrationForSafetyManagementCertificate;
    administrationForSecurityCertificate;
    auditorForDocumentOfCompliance;
    auditorForSafetyManagementCertificate;
    auditorForSecurityCertificate;
    dateOfIssuanceForDocumentOfCompliance;
    dateOfExpiryForDocumentOfCompliance;
    dateOfIssuanceForSafetyManagementCertificate;
    dateOfExpiryForSafetyManagementCertificate;
    dateOfIssuanceForInternationalShipSecurityCertificate;
    dateOfExpiryForInternationalShipSecurityCertificate;
    grossTonnage;
    netTonnage;
    lengthOverall;
    breadthOverall;
    workingLanguage;
    callSign;
    mmsiNumber;
    shipType;
    seaArea;
    equipmentAvailability;
    unlimitedEnginePower;
    limitedEnginePower;
    unlimitedShaftPower;
    limitedShaftPower;
    companyDetails;
    charterers;
    classes;
    companyResponsibleForVesselManagement;
    flagStates;
    portOfRegistration;
    vesselIMO;
    vesselName;
    vesselOwners;
    logbooksKeptAdditionally;
    ismRelevantChecklists;
    checklists;
    version;
    signature;
    staticDocuments;
    constructor(vesselParticulars = {}) {
        super();
        this.createdTimestamp = getUtcNow();
        Object.assign(this, {
            administrationForDocumentOfCompliance: '',
            administrationForSafetyManagementCertificate: '',
            administrationForSecurityCertificate: '',
            auditorForDocumentOfCompliance: '',
            auditorForSafetyManagementCertificate: '',
            auditorForSecurityCertificate: '',
            dateOfIssuanceForDocumentOfCompliance: '',
            dateOfExpiryForDocumentOfCompliance: '',
            dateOfIssuanceForSafetyManagementCertificate: '',
            dateOfExpiryForSafetyManagementCertificate: '',
            dateOfIssuanceForInternationalShipSecurityCertificate: '',
            dateOfExpiryForInternationalShipSecurityCertificate: '',
            workingLanguage: '',
            callSign: '',
            mmsiNumber: '',
            shipType: '',
            seaArea: '',
            equipmentAvailability: '',
            companyDetails: '',
            charterers: [],
            classes: [],
            companyResponsibleForVesselManagement: [],
            flagStates: [],
            portOfRegistration: '',
            vesselIMO: '',
            vesselName: '',
            vesselOwners: [],
            logbooksKeptAdditionally: [],
            staticDocuments: [],
        }, vesselParticulars);
    }
}
//# sourceMappingURL=VesselParticulars.js.map